// Todo: Add office.com origin parameter to all of urls called from formsService
export const DESIGNER_MOBILE_URL: string = '/Pages/MobileDesignPage.aspx';
export const DESIGNER_URL: string = '/Pages/DesignPage.aspx';
export const NEO_DESIGN_URL: string = '/Pages/DesignPageV2.aspx';